const BASE_URL = "https://www.cyberpunk.pk";

export const absoluteUrl = (path = "/") => {
  if (!path) return BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildBreadcrumbSchema = (items = []) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: absoluteUrl(item.path),
  })),
});

export const buildBlogPostingSchema = (post, category) => {
  if (!post) return null;
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    mainEntityOfPage: absoluteUrl(`/blog/${post.slug}`),
    datePublished: post.dateISO,
    dateModified: post.updatedISO || post.dateISO,
    author: {
      "@type": "Organization",
      name: "Cyberpunk",
    },
    publisher: {
      "@type": "Organization",
      name: "Cyberpunk",
      logo: {
        "@type": "ImageObject",
        url: absoluteUrl("/logo192.png"),
      },
    },
    articleSection: category?.name || post.categorySlug,
    keywords: (post.keywords || []).join(", "),
    inLanguage: "en-PK",
    isAccessibleForFree: true,
  };
};

export const buildFaqSchema = (faqs = []) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (faqs || []).map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});

export const buildSoftwareApplicationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "CDR Analyzer Tool",
  applicationCategory: "SecurityApplication",
  operatingSystem: "Web",
  url: absoluteUrl("/cdr-analyzer"),
  description:
    "Online Call Detail Record analysis for Pakistani LEA workflows including MFC, MFL, IMEI and location-oriented summaries.",
  publisher: {
    "@type": "Organization",
    name: "Cyberpunk",
  },
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "PKR",
  },
});
